module.exports = __webpack_public_path__ + "static/media/check.3e49a8aa.svg";